import React, { useContext } from 'react';
import styled from 'styled-components';
import { useImagesContext } from '../../contexts/ImagesContext';

// import { ReactComponent as Line } from './images/line.svg';

const Item = ({ name, value, hiddenPower }) => {
  console.log('Item', { name, value, hiddenPower });
  return (
    <ItemBlock>
      <Name>{name}</Name>
      <div>
        <Value>{value}</Value>
        {hiddenPower && <Hiddent>{` + ${hiddenPower}`}</Hiddent>}
        {/* <Value>{`99`}</Value>
        <Hiddent>{` + 99`}</Hiddent> */}
      </div>
    </ItemBlock>
  );
};

export const StudentPowerText = ({ power }) => {
  console.log('StudentPowerText', { power });
  const { images } = useImagesContext();
  return (
    <Block>
      <Item
        name="HP"
        value={power && power.hp > 0 ? power.hp : '-'}
        hiddenPower={
          power && power.hiddenPowerPoint.hp ? power.hiddenPowerPoint.hp : null
        }
      />
      <Item
        name="ATK"
        value={power && power.atk > 0 ? power.atk : '-'}
        hiddenPower={
          power && power.hiddenPowerPoint.atk
            ? power.hiddenPowerPoint.atk
            : null
        }
      />
      <Item
        name="DEF"
        value={power && power.def > 0 ? power.def : '-'}
        hiddenPower={
          power && power.hiddenPowerPoint.def
            ? power.hiddenPowerPoint.def
            : null
        }
      />
      {/* <Line /> */}
      <Line src={images['line.png']} alt="" />
      <Item
        name="เจาะ"
        value={power && power.piercing > 0 ? `${power.piercing}%` : '-'}
      />
      <Item
        name="LUCK"
        value={power && power.luck > 0 ? `${power.luck}%` : '-'}
      />
    </Block>
  );
};

const Block = styled.div`
  // display: flex;
  // flex-direction: column;
  // margin: 0 0 1rem;
  position: absolute;
  left: 130px;
  top: 400px;
  // width: 360px;
  width: 450px;
`;

const ItemBlock = styled.div`
  margin-top: -8px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  // width: 100%;
  // margin: 0 0 1rem;
`;

const Name = styled.span`
  // margin: 0 0 0.5rem;
  font-family: PSLxText;
  font-weight: bold;
  font-size: 90px;
  width: 50%;
  text-align: center;
  color: #5a3b18;
  paint-order: stroke fill;
  -webkit-text-stroke: 0.05em #ceaa7b;
`;

const Value = styled.span`
  font-size: 1.1rem;
  margin: 0;
  font-family: PSLxText;
  font-weight: normal;
  font-size: 90px;
  color: white;
  width: 50%;
  text-align: center;
`;

const Hiddent = styled.span`
  font-size: 1.1rem;
  margin: 0;
  font-family: PSLxText;
  font-weight: bold;
  font-size: 90px;
  color: green;
  width: 50%;
  text-align: center;
  paint-order: stroke fill;
  -webkit-text-stroke: 0.05em white;
`;

const Line = styled.img`
  margin-left: 50px;
`;
